export { default } from './UnscoredCategoryPageBackgroundTextureCardTypesSection'
